/* eslint-disable linebreak-style */
import { all } from 'redux-saga/effects';
import auth from './auth'
import { userSaga } from '../redux/UserManagement/saga';
import projectSagas from '../redux/Project/saga';
import setupDataSaga from '../redux/Project/setupData/saga';
import materialsDataSaga from '../redux/Project/materialsData/saga';
import registryDataSaga from '../redux/Project/registryData/saga';
import { weldDataSaga } from '../redux/WeldData/saga';
import productionDataSaga from '../redux/ProductionData/saga';
import { teamMembersSaga } from '../redux/TeamMembers';
import deviceSaga from '../redux/device/saga';
import { userTableLayoutSaga } from '../redux/UserTableLayout/saga';
import reportDraftsSaga from '../redux/ReportDrafts/saga';
import ndtAnalyticsSaga from '../redux/NDT Analytics/saga';
import weldAnalyticsSaga from '../redux/WeldAnalytics/saga';
import pipefitterSaga from '../redux/Pipefitter/saga';
import coatingPumphouseSaga from '../redux/CoatingPumphouse/saga';
import spoolsbaseSaga from '../redux/Spoolsbase/saga';
import pipeMillReportSaga from '../redux/Project/pipeMillReport/saga';

export default function* rootSaga() {
  yield all([
    auth(),
    userSaga(),
    projectSagas(),
    setupDataSaga(),
    materialsDataSaga(),
    registryDataSaga(),
    weldDataSaga(),
    productionDataSaga(),
    teamMembersSaga(),
    deviceSaga(),
    userTableLayoutSaga(),
    reportDraftsSaga(),
    ndtAnalyticsSaga(),
    weldAnalyticsSaga(),
    pipefitterSaga(),
    coatingPumphouseSaga(),
    spoolsbaseSaga(),
    pipeMillReportSaga(),
  ]);
} 
